import React from 'react';
import PropTypes from 'prop-types';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => {

  const handleClick = (e) => {
    e.preventDefault();
    onClick(e);
  };

  return (
    <a
      href=""
      ref={ref}
      onClick={handleClick}
    >
      {children}
    </a>
  );
});

CustomToggle.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.element,
    PropTypes.object
  ]),
  onClick: PropTypes.func
};

export default CustomToggle;
